import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Icons } from '@cld/icon';
import Toggle from '@cld/toggle';
import { typography } from '@cld/typography';
import { BaseSectionProps } from './common/BaseSectionProps';
import { SectionWrapper } from './common/SectionWrapper';
import { HeaderIcon } from './common/HeaderIcon';

const Header = styled.div`
  display: flex;
  align-items: center;
  ${typography.sm.highContrast};
  padding: 0 ${globalTheme.spacing.md};
`;

const HeaderIconWrapper = styled.div`
  margin-left: -${globalTheme.spacing.xxs};
  margin-right: ${globalTheme.spacing.sm};
`;

const Title = styled.div`
  padding: ${globalTheme.spacing.xs} 0;
`;

const ToggleWrapper = styled.div`
  margin-left: auto;
`;

const Content = styled.div<{ active: boolean }>`
  padding: ${globalTheme.spacing.md};

  ${(props) => !props.active && css`
    opacity: 0.3;
    pointer-events: none;
  `};
`;

export interface ToggleableSectionProps extends BaseSectionProps {
  active: boolean,
  onToggle: (newState: boolean) => void,
  icon?: Icons,
}

export const ToggleableSection: FC<ToggleableSectionProps> = ({ title, highlight, showHorizontalLine = true, active, onToggle, icon, children }) => (
  <SectionWrapper highlight={highlight} showHorizontalLine={showHorizontalLine}>
    <Header data-test="toggleable-section-header">
      {icon && (
        <HeaderIconWrapper>
          <HeaderIcon iconName={icon} />
        </HeaderIconWrapper>
      )}
      <Title>{title}</Title>
      <ToggleWrapper>
        <Toggle checked={active} onChange={onToggle} />
      </ToggleWrapper>
    </Header>
    <Content active={active} data-test="toggleable-section-content">
      {children}
    </Content>
  </SectionWrapper>
);
